import * as yup from "yup";

import type { TFunction } from "i18next";

const MIN_HOURS = 1;

// Validación de la carga de horas vía Jira (proyecto + issue + horas/día).

/**
 * `projectId` e `issueId` salen como string: los `<Select>` de MUI entregan el
 * id numérico del `<MenuItem>` y `yup.string()` lo castea al validar, aunque
 * `ChargeHourJiraDTO` los declare numéricos. Comportamiento
 * preexistente (hallazgo previo a la migración); no se corrige en esta
 * migración tipo-only.
 */
export interface ChargeHourJiraValues {
  projectId: string;
  issueId: string;
  hoursPerDay: number;
}

export const buildChargeHourJiraSchema = (t: TFunction): yup.ObjectSchema<ChargeHourJiraValues> =>
  yup
    .object()
    .shape({
      projectId: yup.string().typeError(t("isRequired")).required(t("isRequired")),
      issueId: yup.string().typeError(t("isRequired")).required(t("isRequired")),
      hoursPerDay: yup
        .number()
        .typeError(t("isRequired"))
        .required(t("isRequired"))
        .min(MIN_HOURS, t("minimumValueShouldBeHour", { minHours: MIN_HOURS })),
    })
    .required();
